// extracted by mini-css-extract-plugin
export default {"AddLogIcon":"AddButton_AddLogIcon__5Znn4","AddLog":"AddButton_AddLog__pUr-p"};